import React from "react";

function EditResume() {
  return <div>EditResume</div>;
}

export default EditResume;
